import { render, staticRenderFns } from "./FiveSteps.vue?vue&type=template&id=ef1fde64&scoped=true&"
import script from "./FiveSteps.vue?vue&type=script&lang=ts&"
export * from "./FiveSteps.vue?vue&type=script&lang=ts&"
import style0 from "./FiveSteps.vue?vue&type=style&index=0&id=ef1fde64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1fde64",
  null
  
)

export default component.exports